export const EmailLookupState = Object.freeze({ Exists: 1, Pending: 0, NotExists: -1 });

export const isValidEmailFormat = (value) => {
    
    // VERY basic email validation pattern:
    // - One or more character that is NOT "@", followed by
    // - An "@", followed by
    // - One or more character that is NOT "@"
    const emailPattern = /^((?!@)\S)+[@]((?!@)\S)+/g;

    if (value && value.length >= 5 && emailPattern.test(value)) {
        return true;
    }

    return false;
}

export const emailExists = (emailAddress) => {
    const url = '/api/account/email-exists?emailAddress=' + emailAddress;
    return fetch(url)
        .then((response) => response.json())
        .then((data) => {
            if (data === true) {
                return EmailLookupState.Exists;
            } else {
                return EmailLookupState.NotExists;
            }
        })
        .catch(function () {
            return EmailLookupState.NotExists;
        });
}
